import Head from 'next/head'
import Link from 'next/link'
import styles from '@/components/contact/ContactPage.module.scss'
import classNames from 'classnames'
import PageHeaderBanner from '@bww/beke-ui/PageHeader'
import ContactForm from '@bww/beke-ui/ContactForm'

import instagramIcon from '@bww/beke-ui/icons/instagram.svg'

import { siteConfig } from '@bww/beke-lib/site-config'

export default function ContactPage() {
  return (
    <>
      <Head>
        <title>Contact Bathroom Elegance</title>
        <meta
          name="description"
          content="Call our Poole-based bathroom team or send a message online."
        />
      </Head>
      <PageHeaderBanner title="Contact Bathroom Elegance" noMargin />
      <div className="container">
        <div className={styles.panelsContainer}>
          <div className={styles.panel}>
            <h2 className={classNames('h3', styles.title)}>
              <strong>How can we help?</strong>
            </h2>
            <div className={styles.formWrapper}>
              <ContactForm />
            </div>
          </div>
          <div className={styles.offlinePanel}>
            <h3 className={classNames('capText')}>Poole Showroom</h3>
            <a
              href={`tel:${siteConfig.tel.replace(' ', '')}`}
              className={classNames('h1 match', styles.tel)}
            >
              {siteConfig.tel}
            </a>
            <div className={styles.address}>
              <div>{siteConfig.companyName}</div>
              <div>{siteConfig.address.address1}</div>
              <div>{siteConfig.address.address2}</div>
              <div>
                {siteConfig.address.locality}{' '}
                <strong>{siteConfig.address.postCode}</strong>
              </div>
            </div>
            <div className={styles.openingHours}>
              <h4>Opening Hours</h4>
              <div>
                Monday to Friday <strong>9am – 5pm</strong>
                <br />
                Saturday <strong>9am – 4pm</strong>
                <br />
                Sunday <strong>Closed</strong>
                <br />
              </div>
            </div>
            <Link
              href="/poole-showroom"
              className="button button--small button--onDark"
            >
              About our showroom
            </Link>
            <div className={styles.social}>
              <div>Social</div>
              <a
                href="https://www.instagram.com/bathroomelegancepoole/"
                aria-label="Bathroom Elegance on Instagram"
              >
                <svg width={16} height={16} viewBox="0 0 256 256">
                  <use href={`${instagramIcon.src}#icon`} />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
